import { GoogleSignIn } from '@capawesome/capacitor-google-sign-in';
import { AppleSignIn, SignInScope } from '@capawesome/capacitor-apple-sign-in';
import { FacebookLogin } from 'capacitor-facebook-login';

export const useCapacitorSocialLogin = () => {
  const initialize = async ({
    googleClientId,
    appleClientId
  }: {
    googleClientId: string;
    appleClientId: string;
    facebookAppId?: string;
  }) => {
    await GoogleSignIn.initialize({
      clientId: googleClientId
    });

    await AppleSignIn.initialize({
      clientId: appleClientId
    });

    await FacebookLogin.initialize();
  };

  const googleLogin = async () => {
    return await GoogleSignIn.signIn();
  };

  const appleLogin = async ({ redirectUrl, state }: { redirectUrl: string; state: string }) => {
    return await AppleSignIn.signIn({
      scopes: [SignInScope.Email, SignInScope.FullName],
      redirectUrl,
      state
    });
  };

  const facebookLogin = async () => {
    return await FacebookLogin.signIn();
  };

  const facebookCurrentToken = async () => {
    return await FacebookLogin.getCurrentAccessToken();
  };

  const facebookLogout = async () => {
    await FacebookLogin.signOut();
  };

  return {
    initialize,
    googleLogin,
    appleLogin,
    facebookLogin,
    facebookCurrentToken,
    facebookLogout
  };
};
